// Lightweight haptic feedback helpers for tap confirmation and
// milestone moments. Wraps navigator.vibrate, which is a no-op on
// desktop and Safari iOS (iOS Safari does not yet expose Vibration API
// to JS — taps fall back to the visual :active transform on CTAButton).
//
// Patterns are short so they feel like a confirmation rather than an
// alert. Respects prefers-reduced-motion: when the user has set that
// preference, we skip the vibration too — reduced-motion implies a
// preference for less sensory stimulation across the board.

function reducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

function vibrate(pattern) {
  if (typeof navigator === 'undefined') return;
  if (typeof navigator.vibrate !== 'function') return;
  if (reducedMotion()) return;
  try { navigator.vibrate(pattern); } catch { /* Chrome throws if called without user gesture */ }
}

// Short tap — primary CTA press. ~10ms is below the perceptual
// threshold for "buzz" and reads as a subtle confirmation.
export function hapticTap() {
  vibrate(10);
}

// Success — session complete, setting saved. Two short pulses.
export function hapticSuccess() {
  vibrate([14, 60, 14]);
}

// Warning / error — write failed, permission denied. Slightly longer
// single pulse; not a double-pulse pattern so it doesn't feel like an
// alarm.
export function hapticWarn() {
  vibrate(24);
}

// Milestone — streak day 7 / 30 / 100, program graduation. A three-
// pulse pattern so it reads as a tiny celebration on top of the tap.
export function hapticMilestone() {
  vibrate([18, 50, 18, 50, 30]);
}
